import 'what-input'
import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'
import focus from '@alpinejs/focus'
import { RowSlider } from '@js/components/rowSlider.ts'
import { ProductSlider } from '@js/components/productSlider.ts'
import { ContentSlider } from '@js/components/contentSlider.ts'
import { RecipeSlider } from '@js/components/recipeSlider.ts'
import { SingleSlider } from '@js/components/singleSlider.ts'
import { Slider } from '@js/components/slider.ts'
import { Modal } from './components/modal.ts'
import { SocialFeed } from '@js/components/socialFeed.ts'
import { WineFinder } from './winefinder/index.ts'
import { C7Cart } from '@js/components/c7Cart.js'
import replaceTextInDocument from './lib/replaceText.ts'
import { fitText, debounceFitText } from './lib/fitText.ts'

// Video facades
import '@js/components/liteYoutube.ts'
import '@js/components/liteVimeo.ts'

window.Alpine = Alpine

Alpine.plugin(intersect)
Alpine.plugin(focus)

Alpine.data('rowSlider', RowSlider)
Alpine.data('productSlider', ProductSlider)
Alpine.data('contentSlider', ContentSlider)
Alpine.data('recipeSlider', RecipeSlider)
Alpine.data('singleSlider', SingleSlider)
Alpine.data('slider', Slider)
Alpine.data('wineFinder', WineFinder)
Alpine.data('c7Cart', C7Cart)
Alpine.data('modal', Modal)
Alpine.data('socialFeed', SocialFeed)

Alpine.start()

document.addEventListener('DOMContentLoaded', () => {
  replaceTextInDocument([
    { search: /J\. Lohr/g, replace: 'J.\u00A0Lohr' },
    { search: /Gesture|GESTURE/g, replace: '<em>%s</em>' },
    { search: /Touching Lives|TOUCHING LIVES/g, replace: '<em>%s</em>' },
  ])
})

window.addEventListener('load', () => {
  fitText()
})
window.addEventListener('resize', () => {
  debounceFitText(250)
})

window.pushDataLayer = function (data: string) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ ecommerce: null })
  window.dataLayer.push(data)
}
